(() => {
  'use strict';
  if (window.__QXAccessibilityReady) return;
  window.__QXAccessibilityReady = true;
  document.documentElement.dataset.qxA11yOwner = '1.0.1';

  let cartOpener = null;
  let wishlistOpener = null;
  let cartWasOpen = false;
  let wishlistWasOpen = false;
  let queued = false;

  const $ = (selector, context = document) => context?.querySelector?.(selector) || null;
  const isUsable = element => element instanceof HTMLElement && document.contains(element) && !element.hidden && element.getClientRects().length > 0;

  const restore = (preferred, fallbackSelector) => {
    const target = isUsable(preferred) ? preferred : $(fallbackSelector);
    if (isUsable(target)) requestAnimationFrame(() => target.focus({ preventScroll: true }));
  };

  const setModalState = (node, open) => {
    if (!node) return;
    const hiddenValue = open ? 'false' : 'true';
    if (node.getAttribute('aria-hidden') !== hiddenValue) node.setAttribute('aria-hidden', hiddenValue);
    try { if (node.inert !== !open) node.inert = !open; } catch (_) {}
  };

  const sync = () => {
    queued = false;
    const cart = $('[data-qx-cart-shell]');
    const wishlist = $('[data-qx-wishlist-drawer]');
    const cartOpen = Boolean(cart?.classList.contains('is-open'));
    const wishlistOpen = Boolean(wishlist && !wishlist.hidden);

    setModalState(cart, cartOpen);
    setModalState(wishlist, wishlistOpen);

    if (cartWasOpen && !cartOpen) {
      const active = document.activeElement;
      if (!isUsable(active) || active === document.body || active?.closest?.('[data-qx-cart-shell]')) restore(cartOpener, '[data-cart-open]');
      cartOpener = null;
    }
    if (wishlistWasOpen && !wishlistOpen) {
      const active = document.activeElement;
      if (!isUsable(active) || active === document.body || active?.closest?.('[data-qx-wishlist-drawer]')) restore(wishlistOpener, '[data-qx-wishlist-open]');
      wishlistOpener = null;
    }

    cartWasOpen = cartOpen;
    wishlistWasOpen = wishlistOpen;
  };

  const queueSync = () => {
    if (queued) return;
    queued = true;
    queueMicrotask(sync);
  };

  document.addEventListener('pointerdown', event => {
    const cartTrigger = event.target.closest?.('[data-cart-open]');
    if (cartTrigger) cartOpener = cartTrigger;
    const wishlistTrigger = event.target.closest?.('[data-qx-wishlist-open]');
    if (wishlistTrigger) wishlistOpener = wishlistTrigger;
  }, true);

  document.addEventListener('keydown', event => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const cartTrigger = event.target.closest?.('[data-cart-open]');
    if (cartTrigger) cartOpener = cartTrigger;
    const wishlistTrigger = event.target.closest?.('[data-qx-wishlist-open]');
    if (wishlistTrigger) wishlistOpener = wishlistTrigger;
  }, true);

  const start = () => {
    sync();
    if (!document.body) return;
    new MutationObserver(queueSync).observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'hidden', 'aria-hidden']
    });
    document.addEventListener('shopify:section:load', queueSync);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
